import { useMutation, UseMutationOptions } from 'react-query';
import { DevopsAPI } from 'api';

export const useAddRequestToDevops = (config?: UseMutationOptions) => {
  return useMutation(DevopsAPI.addRequestToDevops, { ...config });
};
